<script>
import { movementParameters } from 'config';
import template from '../../views/partials/movements/cluster-popup.html';

export default {
  name: 'MovementClusterPopup',
  template,
  props: {
    movement: Object,
    group: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  computed: {
    lang() {
      return this.$language.current;
    },
  },
  data() {
    return {
      movementParameters,
    };
  },
};
</script>
